import axios from '../axios'

// サイドバー未読バッジ件数
const getFeedbackUnreadApi = async () => {
  return await axios.get('api/lms/feedback/unread')
}

export default getFeedbackUnreadApi
